import styled from 'styled-components';

const Link = styled.a`
  text-decoration: none;
  color: #3f51b5;
`;
export default Link;
